import { createStore, applyMiddleware, AnyAction } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';
import rootReducer from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { sentryReduxEnhancer } from './middlewares/sentry-redux';
import { loadFromStorage, saveToStorage } from './local-storage';
import { UserPermissionsHandler } from '../utils/user-permissions';

const store = createStore(
  rootReducer,
  loadFromStorage(),
  composeWithDevTools(applyMiddleware(thunk), sentryReduxEnhancer)
);

store.subscribe(() => {
  // console.log('store.subscribe called');
  saveToStorage(store.getState());
});

//Init state classses
//TODO: find a more generic way to resolve this kind of issues
try {
  if (store.getState().login.permissions) {
    store.getState().login.permissions = new UserPermissionsHandler(store.getState().login.user?.permissions || []);
  }
} catch (error) {
  console.error(error);
}

export type StoreState = ReturnType<typeof rootReducer>;
export type AppDispatch = ThunkDispatch<StoreState, unknown, AnyAction>;
export type GetState = () => StoreState;

export default store;
